/**
 * LoginModal.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoginForm from 'components/LoginForm';


import userActions from 'store/user/actions';

/**
 * View you submitted questions
 *
 */
export class LoginModal extends Component {
  login = (signupFunc) => {
    const { onClose, data } = this.props;
    signupFunc(data.location);
    onClose();
  }

  render() {
    const { facebookLogin, gmailLogin } = this.props;

    return (
      <LoginForm
        facebookLogin={() => this.login(facebookLogin)}
        gmailLogin={() => this.login(gmailLogin)}
        headlineText="Sign Up To Start Receiving Trivia Questions!"
      />
    );
  }
}

LoginModal.propTypes = {
  facebookLogin: PropTypes.func.isRequired,
  gmailLogin: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    session: state.user.session,
  };
}, {
  facebookLogin: userActions.facebookLogin,
  gmailLogin: userActions.gmailLogin,
})(LoginModal);
